import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { LastFiveGames as LastFiveGamesComponent } from '../../../components';
import { ApiWidgetType, matchStageTranslationMap, StatsTypes } from '../../../constants';
import type { LatestGame } from '../../../components/LastFiveGames/LastFiveGames.types';
import type { LastMatch as LastMatchApi } from '../../../types';
import { useStatsData } from '../../../hooks';

const LastFiveGames = () => {
  const translate = useNewTranslations();
  const { widget } = useStatsData({
    shouldFetchTeamsData: false,
    widgetType: StatsTypes.LAST_5_GAMES,
  });

  if (!widget || widget.type !== ApiWidgetType.LAST_5_GAMES || !widget?.data) {
    return null;
  }

  const { homeMatches, awayMatches, homeTeam, awayTeam } = widget.data;

  const mapLatestApiGames = (games: LastMatchApi[]): LatestGame[] =>
    games.map((game) => ({
      ...game,
      stage: game.stage ? translate(matchStageTranslationMap[game.stage]) : game.stage,
      result: game.outcome,
      homeGoalScorers: game.homeGoalscorers,
      awayGoalScorers: game.awayGoalscorers,
    }));

  const latestHomeGames = mapLatestApiGames(homeMatches);
  const latestAwayGames = mapLatestApiGames(awayMatches);

  const areBothTeamsWithoutGames = latestHomeGames.length === 0 && latestAwayGames.length === 0;

  if (areBothTeamsWithoutGames) {
    return null;
  }

  return (
    <Section contentClassName="p-0" name={translate('PreMatchStats.Last5Games')}>
      <LastFiveGamesComponent
        homeTeamName={homeTeam}
        awayTeamName={awayTeam}
        latestHomeGames={latestHomeGames}
        latestAwayGames={latestAwayGames}
      />
    </Section>
  );
};

export default LastFiveGames;
